import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../../config.json'
import Translation from '../../Translation/cont/Translation'
import Button from '../../general/Button'

const NewsletterPreviewButtons = ({
    hasChanges,
    campaignId,
    hasSendNewsletter,
    selectedItems,
    requestUpdateData,
    requestSendNewsletter
}) => {
    let buttonTextTransId

    if(hasChanges) {
        buttonTextTransId = 'print_newsletter_save_content'
    } else if(!selectedItems) {
        buttonTextTransId = 'print_newsletter_select_content'
    } else if(hasSendNewsletter) {
        buttonTextTransId = 'print_newsletter_send_newsletters'
    } else {
        buttonTextTransId = 'print_newsletter_create_newsletter'
    }
    
    return (
        <div className="buttons-submit-cancel">
            {hasChanges ? (
                <Button
                    className="button button-cancel" 
                    transId="save_button"
                    onClick={() => requestUpdateData()}
                    hideText={false}
                />
            ) : (
                <Link className="button button-cancel" to={`${config.routes.newsletter.path}/campaign/${campaignId}/vorschau`} >
                    <span className="text"><Translation id="button_preview">Vorschau</Translation></span>
                </Link>
            )}

            <Button
                className="button button-submit" 
                transId={buttonTextTransId}
                onClick={hasChanges ? () => requestUpdateData() : selectedItems ? () => requestSendNewsletter() : () => {}}
                hideText={false}
                disabled={!selectedItems}
            />
        </div>
    )
}

export default NewsletterPreviewButtons